/**
 * Check if an application step is optional
 *
 * @param {Array}  applicationSteps
 * @param {string} stepName
 *
 * @returns {boolean}
 */
export default function isApplicationStepOptional(applicationSteps = [], stepName) {
  return applicationSteps.some((step) => step.name.toLowerCase() === stepName && step.required === false);
}
